import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { ClientHeader } from './client-header/client-header';
import { AppLayoutService } from '../app-layout.service';
import { Drawer } from 'primeng/drawer';
import { ClientMenuDrawer } from './client-menu-drawer/client-menu-drawer';

@Component({
  standalone: true,
  selector: 'app-client-layout',
  imports: [ClientHeader, RouterOutlet, Drawer, ClientMenuDrawer],
  templateUrl: './client-layout.html',
  styleUrl: './client-layout.scss',
})
export class ClientLayout {
  sidebarService = inject(AppLayoutService);
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);

  fullWidth = toSignal(
    this._router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let r = this._route;
        while (r.firstChild) r = r.firstChild;
        return !!r.snapshot.data['fullWidth'];
      }),
    ),
    { initialValue: false },
  );
}
